module.exports = __webpack_public_path__ + "static/media/feat_cumberland.7708d384.png";